import { Card } from 'react-bootstrap';

const KPICards = ({ metrics }) => {
  const cards = [
    { label: 'Total Tenants', value: metrics.tenants.total },
    { label: 'Active Tenants', value: metrics.tenants.active },
    { label: 'Trial Tenants', value: metrics.tenants.trial },
    { label: 'Suspended Tenants', value: metrics.tenants.suspended },
    { label: 'Total Projects', value: metrics.projects.total }
  ];

  return (
    <div className="row">
      {cards.map((c, i) => (
        <div className="col-md-2" key={i}>
          <Card className="mb-3 text-center">
            <Card.Body>
              <Card.Title>{c.value}</Card.Title>
              <Card.Text className="text-muted">{c.label}</Card.Text>
            </Card.Body>
          </Card>
        </div>
      ))}
    </div>
  );
};

export default KPICards;
